import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { ClockCounterClockwise } from "@phosphor-icons/react";

function formatEST(isoString) {
  if (!isoString) return "";
  try {
    const d = new Date(isoString);
    return d.toLocaleString("en-US", { timeZone: "America/New_York", month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return isoString;
  }
}

export function StageHistoryDialog({ open, onOpenChange, title, history }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#1A1A2E] border-white/10 max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <ClockCounterClockwise size={20} />
            Stage History
          </DialogTitle>
          <p className="text-sm text-gray-400">{title}</p>
        </DialogHeader>
        <div className="max-h-[400px] overflow-y-auto space-y-3" data-testid="stage-history-list">
          {history.length === 0 ? (
            <p className="text-gray-500 text-sm text-center py-6">No stage changes recorded yet.</p>
          ) : (
            [...history].reverse().map((entry) => (
              <div key={`${entry.changed_at}-${entry.to_stage}`} className="flex items-start gap-3 p-3 rounded-lg bg-white/5 border border-white/10">
                <div className="w-2 h-2 rounded-full bg-blue-500 mt-1.5 shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 text-sm">
                    <span className="text-gray-400 capitalize">{entry.from_stage}</span>
                    <span className="text-gray-600">&rarr;</span>
                    <span className="text-white font-medium capitalize">{entry.to_stage}</span>
                  </div>
                  <p className="text-[11px] text-gray-500 mt-1">
                    {formatEST(entry.changed_at)} &middot; by {entry.changed_by}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
